import { BaseResourceModel } from './base-resource.model';

export class PracaExibicao extends BaseResourceModel {
    constructor(
        public nome?: string,
        public descricao?: string,
    ) {
        super();
    }

    static fromJson(jsonData: any): PracaExibicao {
        return Object.assign(new PracaExibicao(), jsonData);
    }
}
